import moment from 'moment'

// TODO review time zone impact

export function daynumberToString (daynumber) {
  if (daynumber === null) {
    return '<null>'
  }
  return moment(daynumber * 24 * 60 * 60 * 1000).format('ddd Do MMMM YYYY')
}

export function timeToDaynumber (time) {
  if (time === null) {
    return null
  }
  let milli = time.getTime()
  let days = milli / (1000 * 60 * 60 * 24)
  return Math.floor(days)
}

// UTC

export function prettyDateFromUtcTimestampDDMMYYHHMM (utctimestamp) {
  if (utctimestamp === null) {
    return '<null>'
  }
  let mom = moment(utctimestamp)
  return mom.utc().format('DD-MM-YY HH:mm')
}

export function prettyDateFromUtcTimestampYYYYMMDDHHMM (utctimestamp) {
  if (utctimestamp === null) {
    return '<null>'
  }
  let mom = moment(utctimestamp)
  return mom.utc().format('YYYY-MM-DD HH:mm')
}

export function prettyDateFromUtcTimestampDDMMYY (utctimestamp) {
  return moment(utctimestamp).utc().format('DD-MM-YY')
}

export function prettyDateFromUtcTimestampHHMM (utctimestamp) {
  return moment(utctimestamp).utc().format('HH:mm')
}

// Local

export function prettyDateLocalTimestampDDMMYYHHMMZ (utctimestamp) {
  if (utctimestamp === null) {
    return '<null>'
  }
  let mom = moment(utctimestamp)
  return mom.format('DD-MM-YY HH:mm Z')
}
